
import Keyboard from "../../../assets/outline/Keyboard.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function KeyboardIcon({ className, dataTestid = "KeyboardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Keyboard data-testid={dataTestid} className={classes} {...rest} />
  );
}
